// eslint-disable-next-line no-unused-vars
import { Fragment, h, createRef } from 'preact';
import PropTypes from 'prop-types';
import List from './List';
import ListToggle from './ListToggle';
import ListAutocomplete from './ListAutocomplete';

/**
 * The main component.
 *
 * @param {object} props Props
 * @param {string} props.group The facet group.
 * @param {string} props.label The facet label.
 * @param {array} props.items The facet items.
 * @param {string} props.type The input type.
 * @returns {object} JSX
 */
const ItemList = ( { group, items, label, type } ) => {

	// Determine what UI we're using for this.
	const useAutocomplete = 30 < items.length;
	const useToggle = 15 < items.length && !useAutocomplete;
	const useList = !useToggle && !useAutocomplete;

	window.MSRSearch.slot = -1;

	// Have checked items come first in order so they can be seen.
	const sortedItems = items.sort( ( a, b ) => ( a.selected === b.selected ) ? 0 : a.selected ? -1 : 1 );

	// If Episodes order alphabetically.
	if ( 'Episodes' === label ) {
		sortedItems.sort( ( a, b ) => b.label.localeCompare( a.label ) );
	}


	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{items.length ? (
				<fieldset className="form-group">
					<legend className="m-0">
						<h3 className="h6 pb-2">{label}</h3>
					</legend>
					{useList && <List type={type} items={sortedItems} name={group} />}
					{useToggle && (
						<ListToggle type={type} items={sortedItems} name={group} label={label} />
					)}
					{useAutocomplete && (
						<ListAutocomplete type={type} items={sortedItems} name={group} label={label} />
					)}
				</fieldset>
			) : null}
		</>
	);
};

ItemList.propTypes = {
	group: PropTypes.string.isRequired,
	items: PropTypes.arrayOf( PropTypes.object ).isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
};

export default ItemList;
